/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedCeproDocUpdateRequest } from '../types/PatchedCeproDocUpdate';
import type { CeproDocUpdateResponse } from '../types/CeproDocUpdate';

export type CeproDocsPartialUpdateRequest = PatchedCeproDocUpdateRequest;
export type CeproDocsPartialUpdateResponse = CeproDocUpdateResponse;

export type CeproDocsPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/cepro_docs/{id}/
 *
 * ```yaml
 * operationId: cepro_docs_partial_update
 * tags:
 *   - cepro_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedCeproDocUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedCeproDocUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedCeproDocUpdate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/CeproDocUpdate'
 *     description: ''
 * ```
 */
export const ceproDocsPartialUpdateOperation = ({ id, ...rest }: CeproDocsPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/cepro_docs/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/cepro_docs/{id}/' };
  };

/**
 * PATCH /dmx-server/cepro_docs/{id}/
 *
 * ```yaml
 * operationId: cepro_docs_partial_update
 * tags:
 *   - cepro_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedCeproDocUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedCeproDocUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedCeproDocUpdate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/CeproDocUpdate'
 *     description: ''
 * ```
 */
export const ceproDocsPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: CeproDocsPartialUpdateQuery;
  request: PatchedCeproDocUpdateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<CeproDocUpdateResponse>> => {
  const operation = ceproDocsPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
